import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { CameraIndexService } from './CameraIndexService';
import { AbstractComponent } from '../../../../core/common/component/AbstractComponent';

import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-camera',
  templateUrl: './CameraIndex.html',
  styleUrls: ['./CameraIndex.scss'],
})
export class CameraIndexComponent extends AbstractComponent {
  public scope: any = {
    wait: false,
  };

  /**  */
  constructor(
    private title: Title,
    private dialog: MatDialog,
    private service: CameraIndexService
  ) {
    super();
    title.setTitle('Dashboard');
  }

  public componentWillMount() {
    window.scrollTo(0, 0);
  }
  /**  */
  public render() {}
}
